function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function callOnLoad(callback) {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
}

function callOnDocReady(callback) {
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', callback)
  } else {
    callback()
  }
}

function debounce(fn, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let wait = false;
  return (...args) => {
    if (wait) return;

    fn(...args);
    wait = true;

    setTimeout(() => {
      wait = false;
    }, delay);
  };
}

// TODO: Test with rest parameters
function once(fn) {
  let ran = false;
  let result;
  return function (...args) {
    if (ran) return result;
    result = fn.apply(this, args);
    ran = true;
    return result;
  };
}

// TODO: Test with rest parameters
function memoize(fn) {
  const cache = new Map();
  return function (...args) {
    const key = JSON.stringify(args);
    if (cache.has(key)) return cache.get(key);

    const result = fn.apply(this, args);
    cache.set(key, result);
    return result;
  };
}

function curry(fn, arity = fn.length) {
  return function curried(...args) {
    if (args.length >= arity) return fn(...args);
    return function (...moreArgs) {
      return curried(...args, ...moreArgs);
    };
  };
}

// TODO: Test using quokka
function partial(fn, ...args) {
  return (..._args) => fn(...args, ..._args);
}

function pipe(...fns) {
  return function piped(...args) {
    return fns.reduce((result, fn) => [fn.call(this, ...result)], args)[0];
  };
}

function compose(...fns) {
  return function composed(...args) {
    return fns.reduceRight((result, fn) => [fn.call(this, ...result)], args)[0];
  };
}

function pick(obj, keys) {
  return keys.reduce((acc, key) => {
    if (obj.hasOwnProperty(key)) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}

function omit(obj, keys) {
  return Object.keys(obj)
    .filter(key => !keys.includes(key))
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

function zip(...arrays) {
  const maxLength = Math.max(...arrays.map(array => array.length));
  return Array.from({ length: maxLength }).map((_, i) => {
    return Array.from({ length: arrays.length }, (_, j) => arrays[j][i]);
  });
}

function range(min, max, step = 1) {
  if (max === undefined) {
    max = min;
    min = step;
  }

  return Array.from({ length: Math.floor((max - min) / step) + 1 }, (_, i) => min + i * step);
}

// Reinject all script tags within an AJAX-loaded element to allow script execution. By default, scripts are disabled when using element.innerHTML.
function reinjectScripts(element) {
  console.debug('Reinjecting script tags for element:', element);

  element.querySelectorAll('script').forEach(oldScriptTag => {
    const newScriptTag = document.createElement('script');
    Array.from(oldScriptTag.attributes).forEach(attribute => {
      newScriptTag.setAttribute(attribute.name, attribute.value);
    });
    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
  });
}

function camelToKebab(str) {
  if (str != str.toLowerCase()) {
    str = str.replace(/[A-Z]/g, m => '-' + m.toLowerCase());
  }

  return str;
}

function parseAttribute(value) {
  if (VALUE_PATTERNS.boolean.test(value)) {
    return value === 'true';
  }

  if (VALUE_PATTERNS.number.test(value)) {
    return Number(value);
  }

  return value;
}